export const Rating = ({name, value, size = 'sm', onChange}) => {
    const displayValue = Math.round(value * 2) / 2;
    const interactive = Boolean(onChange);

    return (
        <div className={`rating rating-${size} rating-half ${interactive ? '' : 'pointer-events-none select-none'}`}>
            {[1, 2, 3, 4, 5].flatMap(star => ([
                <input
                    key={`${star}-half1`}
                    type="radio"
                    name={name}
                    className={`mask mask-star-2 mask-half-1 ${
                        displayValue >= star - 0.5 ? 'bg-[#FE7C22]' : 'bg-gray-200'
                    }`}
                    disabled={!interactive}
                    checked={displayValue === star - 0.5}
                    onChange={() => onChange?.(star - 0.5)}
                    aria-label={`${star - 0.5} stars`}
                />,
                <input
                    key={`${star}-half2`}
                    type="radio"
                    name={name}
                    className={`mask mask-star-2 mask-half-2 ${
                        displayValue >= star ? 'bg-[#FE7C22]' : 'bg-gray-200'
                    }`}
                    disabled={!interactive}
                    checked={displayValue === star}
                    onChange={() => onChange?.(star)}
                    aria-label={`${star} stars`}
                />
            ]))}
        </div>
    );
};